/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useEffect, withMemo } from 'fierry/react';

import Auth from 'solis/auth';


export default withMemo(({ user = 1 }) =>
{
  const auth = use(Auth);

  useEffect(() =>
  {
    auth.setOfflineUser(user);
  }, [ user ]);

  return null;
});
